/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsListMembers } from "../../funcs/authTeamsListMembers.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListTeamMembersRequest$inboundSchema,
};

export const tool$authTeamsListMembers: ToolDefinition<typeof args> = {
  name: "auth-teams-list-members",
  description: `List team members`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsListMembers(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
